<template>
    <div>
        <div class="row_center_end quantity_container" v-if="quantity !== 0">
            <div class="row_center_center quantity">{{ quantity }}</div>
        </div>
        <div class="row_center_between w-full">
            <div class="row_center_center" style="background-color: #DDDDDD; border-radius: 50%; padding: 2px;"
                @click="subtractQuantity">
                <text id="remove" class="button-icon"
                    style="color: #000; font-size: 32px; height: 32px; width: 32px">remove</text>
            </div>

            <div class="row_center_center px-1.5 grow w-0" @click="addQuantity">
                <text class="flex-wrap">{{ product.name }}</text>
                <text class="shrink-0" v-if="product['altAddonPrice'] !== undefined && product.altAddonPrice !== 0">+{{
            product.altAddonPrice }}</text>
                <!-- 一般餐點規格價格 -->
                <text class="shrink-0" v-else-if="product['altAddonPrice'] === undefined && product.price !== 0 && !isProduct">{{
            product.price > 0 ? `+${product.price}` : product.price }}</text>
            </div>

            <div class="row_center_center" style="background-color: #FBCB02; border-radius: 50%; padding: 2px;"
                @click="addQuantity">
                <text id="add" class="button-icon"
                    style="color: #000; font-size: 32px; height: 32px; width: 32px">add</text>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        product: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
        quantity: {
            type: Number,
            default: 0,
            required: true,
        }
    },
    computed: {
        isProduct() {
            return this.products.find(item => item.id === this.product.id)
        },
        products() {
            return this.$store.getters['spreadsheet/products']
        }
    },
    methods: {
        click() {
            this.$emit("click");
        },
        openCustomizePopup() {
            this.$emit("openCustomizePopup");
        },
        subtractQuantity() {
            this.$emit("subtractQuantity");
        },
        addQuantity() {
            this.$emit("addQuantity");
        }
    }
}
</script>
<style lang="scss" scoped>
.quantity_container {
    width: 100%;
    height: 0px;
    position: relative;
}

.quantity {
    position: absolute;
    top: -22px;
    right: -25px;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    background-color: #D60A0A;
    flex-shrink: 0;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    font-family: PingFang SC;
}
</style>